<template>
  <v-scale-transition>
    <panel
      :breadcrumbs="breadcrumbs"
      :title="title"
    >
      <v-card
        color="grey-lighten-4"
        height="320px"
      >
        <!-- <v-toolbar density="compact"> -->
        <v-toolbar density="compact">
          <v-toolbar-title>Reserved</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          />
          <v-spacer />
        </v-toolbar>
        <v-alert
          :value="alertReserved"
          :type="executeAlertType"
          v-html="executeAlertMessage"
        />
        <v-card-text>
          The purpose to reserved 100 number is for
          <v-flex xs7>
            <v-select
              v-model="select"
              :items="selects"
              item-text="text"
              item-value="value"
              label="Select purpose"
            />
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            @click="executeReservedMsisdn"
          >
            Execute Reserved Number
          </v-btn>
        </v-card-actions>
      </v-card>
      <td />
      <td />
      <v-toolbar flat>
        <v-toolbar-title>History</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        />
        <v-spacer />
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="booked"
        :pagination.sync="pagination"
        :rows-per-page-items="[10,25,50,100]"
        class="px-1 pb-1"
        item-key="msisdn"
      >
        <template
          slot="headers"
          slot-scope="props"
        >
          <tr>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :width="header.width"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.align ? `text-xs-${header.align}` : ''
              ]"
              @click="changeSort(header.value)"
            >
              <template v-if="header.align === 'right'">
                <v-icon small>
                  arrow_upward
                </v-icon>
                {{ header.text }}
              </template>
              <template v-else>
                {{ header.text }}
                <v-icon small>
                  arrow_upward
                </v-icon>
              </template>
            </th>
          </tr>
        </template>
        <template #items="props">
          <tr>
            <td class="text-xs-left">
              {{ props.item.msisdn }}
            </td>
            <td class="text-xs-left">
              {{ props.item.dealer }}
            </td>
            <td class="text-xs-left">
              {{ props.item.token }}
            </td>
            <td class="text-xs-left">
              {{ props.item.reservation }}
            </td>
            <td
              v-if="props.item.status === 0"
              class="text-xs-center"
            >
              Available
            </td>
            <td
              v-else
              class="text-xs-center"
            >
              Unavailable
            </td>
            <td
              v-if="props.item.status === 0"
              class="text-xs-right"
            >
              <input
                type="checkbox"
                v-model="checked"
                :value="props.item.msisdn"
                @input="props.item.msisdn= $event.target.value"
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-dialog
        v-model="executeDialog"
        max-width="500px"
      >
        <template #activator="{ on }">
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-on="on"
          >
            Execute Reserved Number
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Execute {{ checked.length }} numbers.</span>
          </v-card-title>

          <v-alert
            :value="true"
            :type="executeAlertType"
            v-html="executeAlertMessage"
          />

          <v-card-actions v-if="show == true">
            <v-card-text>
              The purpose to reserved those number is for
            </v-card-text>
            &nbsp;
            <v-flex xs7>
              <v-select
                v-model="select"
                :items="selects"
                item-text="text"
                item-value="value"
                label="Select purpose"
              />
            </v-flex>
          </v-card-actions>

          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="loading"
              color="blue darken-1"
              @click="executeDialog = false"
            >
              {{ executeAlertType === 'info' ? 'Cancel' : 'Close' }}
            </v-btn>
            <v-btn
              v-show="executeAlertType === 'info'"
              :loading="loading"
              :disabled="loading"
              color="blue darken-1"
              @click="executeBookedMsisdn"
            >
              Execute
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <tr /><td />
      <v-toolbar flat>
        <v-toolbar-title>Document </v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        />
      </v-toolbar>
      <v-data-table
        :headers="reservationHeaders"
        :items="history"
        :pagination.sync="pagination"
        :rows-per-page-items="[5,10,25,50]"
        class="px-1 pb-1"
        item-key="reservation"
      >
        <template #items="props">
          <tr>
            <td class="text-xs-left">
              {{ props.item.reservation }}
            </td>
            <td class="text-xs-right">
              <!-- <v-icon
                small
                color="red lighten-2"
                @click="deleteNews(props.item)"
              >
                mdi-trash-can-outline
              </v-icon> -->
              <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-btn
                    fab
                    dark
                    small
                    :disabled="!enableExport"
                    :loading="!enableExport"
                    color="green"
                    v-on="on"
                    @click="exportReport(props.item)"
                  >
                    <v-icon dark>
                      mdi-microsoft-excel
                    </v-icon>
                  </v-btn>
                </template>
                <span>
                  Export Report
                </span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-snackbar
        v-model="snackbar"
        color="success"
        :timeout="5000"
      >
        {{ snackbarText }}
        <v-btn
          dark
          flat
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </v-snackbar>
      <v-snackbar
        v-model="snackbarError"
        color="error"
        :timeout="5000"
      >
        {{ snackbarText }}
        <v-btn
          dark
          flat
          @click="snackbarError = false"
        >
          Close
        </v-btn>
      </v-snackbar>
    </panel>
  </v-scale-transition>
</template>

<script>
import { createGetParams, createPostParams } from '@/rest'
import zipcelx from 'zipcelx'

const pageTitle = 'Reserved Number'

export default {
  components: {
    Panel: () => import(/* webpackChunkName: "panel" */ '@/components/Panel'),
  },
  data () {
    return {
      title: pageTitle,
      activeItem: null,
      pagination: {
        descending: true,
        sortBy: 'icon',
      },
      alertReserved: false,
      load: true,
      show: true,
      items: [],
      booked: [],
      history: [],
      editedIndex: -1,
      editedItem: {
        reservation: null,
      },
      checked: [],
      loading: false,
      select: null,
      selects: [
        {
          text: 'BR',
          value: 'BR',
        },
        {
          text: 'JDT',
          value: 'JDT',
        },
      ],
      executeDialog: false,
      executeAlert: false,
      executeAlertMessage: null,
      executeAlertType: 'info',
      breadcrumbs: [
        {
          text: 'Operation Kits', disabled: false, to: '/operation/operation_kits',
        },
        {
          text: 'Corporate Kits', disabled: false, to: '/operation/corporate_kits',
        },
        {
          text: pageTitle, disabled: true,
        },
      ],
      headers: [
        {
          text: 'Msisdn',
          align: 'left',
          sortable: true,
          value: 'msisdn',
        },
        {
          text: 'Dealer',
          align: 'left',
          sortable: true,
          value: 'dealer',
        },
        {
          text: 'Token',
          align: 'left',
          sortable: true,
          value: 'token',
        },
        {
          text: 'Reservation',
          align: 'left',
          sortable: true,
          value: 'reservation',
        },
        {
          text: 'Status',
          align: 'center',
          sortable: true,
          value: 'status',
        },
        {
          text: 'Mark',
          align: 'right',
          sortable: true,
          value: 'msisdn',
        },
      ],
      reservationHeaders: [

        {
          text: 'Reservation',
          align: 'left',
          sortable: true,
          value: 'reservation',
        },
        {
          text: 'Document',
          align: 'right',
          sortable: true,
          value: 'status',
        },
      ],
      enableExport: true,
      exportedReport: [],
      exportReportHeader:
          [
            {
              value: 'Msisdn',
              type: 'string',
            },
            {
              value: 'Dealer',
              type: 'string',
            },
            {
              value: 'Token',
              type: 'string',
            },
            {
              value: 'Reservation',
              type: 'string',
            },
          ],
      formTitle: 'Reserved Number History',
      alert: false,
      alertMessage: null,
      snackbar: false,
      snackbarError: false,
      snackbarText: null,
    }
  },

  created: function () {
    this.getReservedMsisdn()
  },

  watch: {
    executeDialog (val) {
      if (val) {
        this.executeAlertType = 'info'
        this.executeAlertMessage = '<div>Please select the purpose and click <strong>EXECUTE</strong> only when you have select the purpose and numbers. </div>'
      }
    },
    exportedReport: function () {
      const config = {
        filename: 'ReservedNumber' + '-' + this.editedItem.reservation,
        sheet: {
          data: [],
        },
      }
      config.sheet.data.push(this.exportReportHeader)
      this.exportedReport.forEach(item => {
        const transaction = [
          {
            value: item.msisdn,
            type: 'string',
          },
          {
            value: item.dealer,
            type: 'string',
          },
          {
            value: item.token,
            type: 'string',
          },
          {
            value: item.reservation,
            type: 'string',
          },
        ]
        config.sheet.data.push(transaction)
      })
      zipcelx(config)
      this.enableExport = true
    },
  },
  methods: {
    changeSort: function (column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },

    getReservedMsisdn () {
      const params = createGetParams({
      })
      this.loading = true
      this.$rest.get('getReservedMsisdn.php', params)
        .then((response) => {
          this.booked = response.data.booked
          this.history = response.data.history
          this.loading = false
        }).catch(error => {
          console.log(error)
          this.loading = false
          this.history = []
        })
    },
    async getBookedMsisdn (report = false) {
      this.loading = true
      const params = createGetParams({
        reservation: this.editedItem.reservation,
      })
      try {
        this.source = this.$rest.CancelToken.source()
        Object.assign(params, { cancelToken: this.source.token })
        const response = await this.$rest.get('getReservedDocument.php', params)
        this.error = null
        this.loading = false
        return response.data
      } catch (error) {
        if (!this.$rest.isCancel(error)) {
          this.error = error.message
          this.loading = false
        }
      }
    },

    exportReport: function (reservation) {
      this.editedIndex = this.history.indexOf(reservation)
      this.editedItem = Object.assign({}, reservation)
      this.enableExport = false
      this.getBookedMsisdn().then(data => {
        this.exportedReport = data.items
      })
    },
    async executeReservedMsisdn () {
      const params = createPostParams({
        action: 'reservedMsisdn',
        token: this.select,
      })

      try {
        this.loading = true
        await this.$rest.post('postAction.php', params)
        this.$nextTick(() => {
          this.alertReserved = true
          this.executeAlertType = 'success'
          this.executeAlertMessage = 'Your request to reserved numbers was successful.'
          this.refreshList()
        })
      } catch (e) {
        this.$nextTick(() => {
          this.alertReserved = true
          this.executeAlertType = 'error'
          this.executeAlertMessage = e.message + ': ' + e.response.data
        })
      } finally {
        this.loading = false
      }
    },

    async executeBookedMsisdn () {
      const params = createPostParams({
        action: 'bookedMsisdn',
        token: this.select,
        id: this.checked.length,
        payload: {
          booked: this.checked,
        },
      })

      try {
        this.loading = true
        await this.$rest.post('postAction.php', params)
        this.$nextTick(() => {
          this.executeAlertType = 'success'
          this.executeAlertMessage = 'Your request to reserved number was successful.'
          this.show = false
          this.refreshList()
        })
      } catch (e) {
        this.$nextTick(() => {
          this.executeAlertType = 'error'
          this.executeAlertMessage = e.message + ': ' + e.response.data
          this.show = false
        })
      } finally {
        this.loading = false
        this.show = false
      }
    },

    // refreshList () {
    //   this.getReservedMsisdn().then(data => {
    //     this.booked = data.booked
    //   })
    //   this.getBookedMsisdn().then(data => {
    //     this.history = data.history
    //   })
    // },

    refreshList () {
      this.getReservedMsisdn()
      this.getBookedMsisdn()
    },

    showError (message) {
      this.alertMessage = message
      this.alert = true
    },
  },
}
</script>

  <style scoped>
  input[type=checkbox] {
      transform: scale(1.5);
  }

  </style>
